import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { CartToast } from '@/components/generals/cart-toast'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:start-3 focus:z-[60] focus:rounded-sm focus:bg-foreground focus:px-4 focus:py-3 focus:text-sm focus:text-background'
            >
                رفتن به محتوای اصلی
            </a>

            <Header />

            <main id='main' className='flex-1 pt-16'>
                {children}
            </main>

            <Footer />
            <CartToast />
        </div>
    )
}
